import * as Sentry from "@sentry/browser";

const DSN = import.meta.env.VITE_SENTRY_DSN

if (DSN) {
    Sentry.init({
        dsn: DSN,
        environment: import.meta.env.VITE_NODE_ENVIRONMENT || 'local',
        denyUrls: [/^chrome-extension:\/\//, /^moz-extension:\/\//, /^safari-(web-)?extension:\/\//],
    });
}
